import React from 'react';
import { Route } from 'react-router-dom';
import BorrowingLayout from 'app/components/borrowing/shared/BorrowingLayout';
import AuthenticatedRoute from 'app/routes/AuthenticatedRoute';
import AccountRequiredRoute from 'app/routes/AccountRequiredRoute';
import FinesPageRoute from './FinesPageRoute';

const basePath = '/v2/fines';

export default (
  <Route path={basePath}>
    <AuthenticatedRoute>
      <AccountRequiredRoute>
        <BorrowingLayout>
          <FinesPageRoute />
        </BorrowingLayout>
      </AccountRequiredRoute>
    </AuthenticatedRoute>
  </Route>
);
